// @flow

export const UPDATE_CART_GROUPS: 'listo/configuration/cart/UPDATE_CART_GROUPS' = 'listo/configuration/cart/UPDATE_CART_GROUPS';
export const UPDATE_CART_GROUPS_PRICE: 'listo/configuration/cart/UPDATE_CART_GROUPS_PRICE' = 'listo/configuration/cart/UPDATE_CART_GROUPS_PRICE';

export default null;
